import { createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
	theme =>
		createStyles({
			root: {
				padding: "10px 16px 0px 16px"
			}
		}),
	{
		name: "MenuInfo",
		index: 1
	}
);

export default useStyles;
